import { Component } from 'react';
import {Col, Form} from 'react-bootstrap';
import {actions, Control, Errors} from 'forms/rrf';
import {connect} from 'react-redux';
import RequiredInput from '../common/form/elements/required-input';
import t from '../../data/translations';

class DeliveryAddressPartial extends Component {
  componentDidMount() {
    const {dispatch, addressDetails, model} = this.props;

    const deliveryFields = [
      'use_delivery_address',
      'delivery_address_1',
      'delivery_address_2',
      'delivery_address_3',
      'use_delivery_address',
      'delivery_eircode',
      'delivery_county',
      'delivery_town'
    ];

    deliveryFields.forEach((d) => {
      dispatch(actions.load(`${model}.${d}`, addressDetails[d]));
    });
  }

  render() {
    const {use} = this.props;
    return (
      <Col
        className="mg-top-30"
        lg={6}
        style={{
          marginLeft: 0,
          paddingLeft: 0
        }}
      >
        <Form.Group>
          <Form.Label>
            <Control.checkbox model=".use_delivery_address"/>
            {' '}
            Use alternate delivery address
          </Form.Label>
          <Errors
            className="errors"
            model=".use_delivery_address"
            show={{touched: true}}
          />
        </Form.Group>
        {use && (
          <div>
            <RequiredInput label="Delivery Address 1" model='.delivery_address_1' placeholder="Delivery Address 1"/>
            <Form.Group>
              <Form.Label>
                {' '}
                Delivery Address 2
              </Form.Label>
              <Control.text
                component={Form.Control}
                model=".delivery_address_2"
                placeholder="Delivery Address 2"
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>
                Delivery Address 2
              </Form.Label>
              <Control.text
                component={Form.Control}
                model=".delivery_address_3"
                placeholder="Delivery Address 3"
              />
            </Form.Group>
            <RequiredInput label="County" model='.delivery_county' placeholder="County"/>
            <RequiredInput label={t('eircode')} model='.delivery_eircode' placeholder={t('eircode')}/>
            <RequiredInput label="Town" model='.delivery_town' placeholder="Town"/>
          </div>
        )}
      </Col>
    );
  }
}

const mapStateToProps = state => ({
  use: state.deep.admin_outlet_view.use_delivery_address,
});

export default connect(mapStateToProps)(DeliveryAddressPartial);
